import React, { Component } from "react";
import axios from "axios";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import { CustomSpinner } from "../utils/CustomComponents";

export default class QAQCLaboratoryTestReportJobPDF extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showModalEmail: false,
			showModalSms: false,
			pdf: "",
			loading: true,
		};
	}

	/**
	 * Get PDF Inspection
	 */
	getPDFReport = async () => {
		const url =
			api +
			`/job/get/load/qc/laboratoryreport/all/pdf/${this.props.match.params.id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.post(url);
			this.setState({
				pdf: data.payload,
				loading: false,
			});
		} catch (err) {
			console.error(err);
			return null;
		}
	};

	componentDidMount() {
		this.getPDFReport();
	}

	render() {
		return (
			<Layout
				title="Laboratory Test Report Job PDF"
				description="Laboratory Test Report Job"
				className="container col-md-12"
			>
				{this.state.loading ? (
					<CustomSpinner />
				) : (
					<iframe src={this.state.pdf} width="95%" style={{ height: "90vh" }} />
				)}
			</Layout>
		);
	}
}
